/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PractitionerRole } from '../models/practitioner-role';

@Injectable({
  providedIn: 'root',
})
export class GoldenRecordProviderService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation multiTenantProviderGoldenRecordCareFindr
   */
  static readonly MultiTenantProviderGoldenRecordCareFindrPath = '/carefindr/practitioner-golden-record/{uid}';

  /**
   * Multi-tenant provider golden record.
   *
   * This interface is invoked when the user clicks on the golden record button of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantProviderGoldenRecordCareFindr()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantProviderGoldenRecordCareFindr$Response(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PractitionerRole>> {

    const rb = new RequestBuilder(this.rootUrl, GoldenRecordProviderService.MultiTenantProviderGoldenRecordCareFindrPath, 'get');
    if (params) {
      rb.path('uid', params.uid, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.header('x-user-id', params['x-user-id'], {});
      rb.query('explain', params.explain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PractitionerRole>;
      })
    );
  }

  /**
   * Multi-tenant provider golden record.
   *
   * This interface is invoked when the user clicks on the golden record button of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantProviderGoldenRecordCareFindr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantProviderGoldenRecordCareFindr(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<PractitionerRole> {

    return this.multiTenantProviderGoldenRecordCareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<PractitionerRole>) => r.body as PractitionerRole)
    );
  }

}
